import React from "react";
import { Box, styled } from "@mui/material";

const Container = styled(Box)({
  position: "fixed",
  zIndex: 2000,       // Higher than MUI AppBar (1100)
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "radial-gradient(55.48% 72.79% at -3.33% 70.62%, rgba(237, 60, 119, 0.14) 0%, rgba(255, 255, 255, 0.20) 100%), radial-gradient(62.97% 57% at 100% 82.23%, #F9E6D1 0%, rgba(255, 255, 255, 0.00) 100%), #FCEFF0",
});

const LoadingScreen = () => (
  <Container>
    <img src="/auth/loading.gif" alt="Loading..." />
  </Container>
);

export default LoadingScreen;
